var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.classes,on:{"click":function($event){return _vm.$emit('button-click')}}},[_vm._t("default"),(_vm.icon)?_c('v-icon',{attrs:{"icon":_vm.icon,"ratio":0.5}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }